module.exports = __webpack_public_path__ + "img/0.37193eb3.png";